module.exports = "https://www.ilove11.top/img/face29.7c84f2fa.gif";